import Vue from "vue";
import VueMaterial from "vue-material";

import Filters from "lib/plugins/Filters";
import VueMaterialPatch from "lib/plugins/VueMaterialPatch";
import App from "components/App";
import Navigation from "components/Navigation";
import Notification from "lib/components/Notification";
import alert from "lib/modules/Alert";
import auth from "lib/modules/Auth";
import cookie from "lib/modules/Cookie";
import cssVars from "lib/modules/CssVars";
import http from "lib/modules/Http";
import news from "lib/modules/News";

auth.init();
cssVars.init();

window.$bus = new Vue();

Vue.use(Filters);
Vue.use(VueMaterial);
Vue.use(VueMaterialPatch);

// Vue Material settings
Vue.material.locale.firstDayOfAWeek = 1;

http.get("/api/v2/user")
.then((response) => {
	new Vue({
		el: "#navigation",
		render(h) {
			return h(Navigation, {
				props: {
					user: response.data
				}
			});
		}
	});

	new Vue({
		el: "#app",
		render(h) {
			return h(App, {
				props: {
					user: response.data
				}
			});
		}
	});
})
.catch((error) => {
	alert.error("Unable to get user data", error.response);
});

new Vue({
	el: "#notification",
	mounted() {
		cookie.checkConsent();
		news.showLatest();
	},
	render(h) {
		return h(Notification);
	}
});
